import { render, staticRenderFns } from "./kxsPrivacyPolicy.vue?vue&type=template&id=5ea32386&scoped=true"
import script from "./kxsPrivacyPolicy.vue?vue&type=script&lang=js"
export * from "./kxsPrivacyPolicy.vue?vue&type=script&lang=js"
import style0 from "./kxsPrivacyPolicy.vue?vue&type=style&index=0&id=5ea32386&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ea32386",
  null
  
)

export default component.exports